import { setSpecificMessage, checkAsync } from "valibot";
setSpecificMessage(
  checkAsync,
  (issue) => `Valeur invalide: reçu ${issue.received}`,
  "fr"
);